import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/tokens.css';

const el = document.getElementById('root');
if (!el) throw new Error('#root がない');
createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/*
 * オフラインで遊べるようにする（`public/sw.js`）。
 *
 * 1人用は最後まで通信が要らないので、電波の無いところで開けないのは
 * 単に配り方の問題である。
 *
 * **開発中は登録しない。** 登録すると、資産が溜まって
 * 「直したのに古い画面が出る」という一番たちの悪い状態になる。
 */
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // 登録できなくても、通信さえあれば遊べる
    });
  });
}
